<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center mb-3">
    <span class="p-input-icon-left flex-grow-1 mr-3">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        (input)="regionsTable.filterGlobal($any($event).target.value, 'contains')"
        placeholder="Search regions"
      />
    </span>
    <button
      pButton
      pRipple
      type="button"
      label="Add region"
      icon="pi pi-plus"
      class="p-button-rounded flex-shrink-0"
      (click)="onAddRegion()"
    ></button>
  </div>

  <p-table
    #regionsTable
    [value]="regionsAsList(account.data?.content)"
    [globalFilterFields]="['name', 'slug', 'state']"
    styleClass="mt-3 p-datatable-striped"
    dataKey="_meta.id"
    responsiveLayout="scroll"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Slug</th>
        <th>State</th>
        <th>Published</th>
        <th style="width: 9rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-region>
      <tr>
        <td>
          <strong>{{ region.name || '(unnamed)' }}</strong>
          <!-- Suburbs ship with their region, so a suburb edit is invisible on
               the site until the region is published. This is the only place
               that says so. -->
          <span *ngIf="region.suburbsChangedAt"
                class="ml-2 text-xs px-2 py-1 border-round app-tint-danger-strong white-space-nowrap"
                title="A suburb in this region was changed and hasn't been published yet">
            suburbs changed
          </span>
        </td>
        <td><code *ngIf="region.slug">{{ region.slug }}</code><span *ngIf="!region.slug" class="muted">—</span></td>
        <td>{{ region.state || '—' }}</td>
        <td>
          <i *ngIf="region.published !== false" class="pi pi-check app-text-ok" title="Published"></i>
          <i *ngIf="region.published === false" class="pi pi-eye-slash text-500" title="Hidden"></i>
        </td>
        <td>
          <button
            pButton pRipple type="button" icon="pi pi-pencil"
            (click)="onEditRegion(region)"
            class="p-button-rounded p-button-text" title="Edit"
          ></button>
          <!-- Scoped publish: this region + its suburbs only. -->
          <button
            pButton pRipple type="button"
            [icon]="publishingSlug === region.slug ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload'"
            (click)="onPublishRegion(region)"
            [disabled]="!region.slug || !!publishingSlug"
            class="p-button-rounded p-button-text"
            [ngClass]="{ 'app-text-nearing': region.suburbsChangedAt }"
            [title]="!region.slug ? 'Give the region a slug first' : 'Publish this region and its suburbs to the staging preview'"
          ></button>
          <button
            pButton pRipple type="button" icon="pi pi-trash"
            (click)="onDeleteRegion(region)"
            class="p-button-rounded p-button-danger p-button-text" title="Remove"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="p-text-center muted p-py-5">
          No regions yet. Use "Add region" to create the first one.
        </td>
      </tr>
    </ng-template>
  </p-table>

</ng-container>

<!-- Shown while the account loads. Without it the modal opens onto an empty
     body for a second or two, which reads as broken rather than busy. -->
<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
